export const RULES_VERSION = 1;
// The server returns the current student's consent requirement.
export function needsRulesAcceptance(required) { return required === true; }
